var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-container" },
    [
      _c("div", { staticClass: "filter-container" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "filter-right" },
          [
            _c(
              "Form",
              {
                staticClass: "compact-form",
                attrs: { model: _vm.searchForm, inline: "", "label-width": 0 },
              },
              [
                _c(
                  "FormItem",
                  [
                    _c(
                      "Select",
                      {
                        staticStyle: { width: "100px" },
                        attrs: { placeholder: "维度" },
                        on: { "on-change": _vm.handleTypeChange },
                        model: {
                          value: _vm.searchForm.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "type", $$v)
                          },
                          expression: "searchForm.type",
                        },
                      },
                      [
                        _c("Option", { attrs: { value: "hourly" } }, [
                          _vm._v("按小时"),
                        ]),
                        _c("Option", { attrs: { value: "daily" } }, [
                          _vm._v("按天"),
                        ]),
                        _c("Option", { attrs: { value: "monthly" } }, [
                          _vm._v("按月"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "FormItem",
                  [
                    _c("DatePicker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        format: _vm.dateFormat,
                        placeholder: "开始日期",
                        clearable: false,
                      },
                      model: {
                        value: _vm.searchForm.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "startDate", $$v)
                        },
                        expression: "searchForm.startDate",
                      },
                    }),
                    _c("span", { staticClass: "date-split" }, [_vm._v("-")]),
                    _c("DatePicker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        format: _vm.dateFormat,
                        placeholder: "结束日期",
                        clearable: false,
                      },
                      model: {
                        value: _vm.searchForm.endDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "endDate", $$v)
                        },
                        expression: "searchForm.endDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "FormItem",
                  [
                    _c(
                      "Button",
                      {
                        staticClass: "action-btn",
                        attrs: {
                          type: "primary",
                          icon: "ios-search",
                          loading: _vm.loading,
                        },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "Button",
                      {
                        staticClass: "action-btn export-btn",
                        attrs: { icon: "md-download" },
                        on: { click: _vm.handleExport },
                      },
                      [_vm._v("导出")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "Row",
        { staticClass: "stat-row", attrs: { gutter: 20 } },
        _vm._l(_vm.statCards, function (item, index) {
          return _c("Col", { key: index, attrs: { xs: 24, sm: 12, md: 6 } }, [
            _c("div", { staticClass: "stat-card", class: item.class }, [
              _c(
                "div",
                { staticClass: "stat-icon-wrapper" },
                [_c("Icon", { attrs: { type: item.icon } })],
                1
              ),
              _c("div", { staticClass: "stat-info" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(item.label)),
                ]),
                _c("div", { staticClass: "stat-value" }, [
                  item.prefix
                    ? _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(item.prefix)),
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n                        " +
                      _vm._s(item.value) +
                      "\n                        "
                  ),
                  item.suffix
                    ? _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(item.suffix)),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "card-bg-icon" },
                [_c("Icon", { attrs: { type: item.icon } })],
                1
              ),
            ]),
          ])
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "chart-section" },
        [
          _c(
            "Row",
            { attrs: { gutter: 20 } },
            [
              _c("Col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "chart-wrapper" }, [
                  _c("div", { staticClass: "chart-header" }, [
                    _c("div", { staticClass: "chart-title" }, [
                      _vm._v("请求量趋势"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "chart-action" },
                      [_c("Icon", { attrs: { type: "ios-pulse" } })],
                      1
                    ),
                  ]),
                  _c("div", {
                    ref: "requestCountChart",
                    staticClass: "chart-canvas",
                  }),
                ]),
              ]),
              _c("Col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "chart-wrapper" }, [
                  _c("div", { staticClass: "chart-header" }, [
                    _c("div", { staticClass: "chart-title" }, [
                      _vm._v("响应耗时分析"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "chart-action" },
                      [_c("Icon", { attrs: { type: "ios-time-outline" } })],
                      1
                    ),
                  ]),
                  _c("div", {
                    ref: "responseTimeChart",
                    staticClass: "chart-canvas",
                  }),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
            [
              _c("Col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "chart-wrapper" }, [
                  _c("div", { staticClass: "chart-header" }, [
                    _c("div", { staticClass: "chart-title" }, [
                      _vm._v("接口成功率"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "chart-action" },
                      [_c("Icon", { attrs: { type: "ios-pie-outline" } })],
                      1
                    ),
                  ]),
                  _c("div", {
                    ref: "successRateChart",
                    staticClass: "chart-canvas",
                  }),
                ]),
              ]),
              _c("Col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "chart-wrapper" }, [
                  _c("div", { staticClass: "chart-header" }, [
                    _c("div", { staticClass: "chart-title" }, [
                      _vm._v("异常分布"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "chart-action" },
                      [_c("Icon", { attrs: { type: "ios-alert-outline" } })],
                      1
                    ),
                  ]),
                  _c("div", {
                    ref: "errorCountChart",
                    staticClass: "chart-canvas",
                  }),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-section" },
        [
          _vm._m(1),
          _c("Table", {
            attrs: {
              columns: _vm.tableColumns,
              data: _vm.tableData,
              loading: _vm.loading,
              "row-class-name": _vm.rowClassName,
              size: "small",
            },
            scopedSlots: _vm._u([
              {
                key: "successRate",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticClass: "status-cell" }, [
                      _c("span", {
                        staticClass: "status-dot",
                        class: _vm.getSuccessRateColor(row.successRate),
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            row.successRate
                              ? row.successRate.toFixed(2) + "%"
                              : "0.00%"
                          )
                        ),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "filter-left" }, [
      _c("span", { staticClass: "page-title" }, [_vm._v("请求日志分析")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("span", { staticClass: "section-title" }, [_vm._v("详细数据报表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }